/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDeliveryAreas200ResponseInnerGeometryAnyOfInner
 */
export interface GetDeliveryAreas200ResponseInnerGeometryAnyOfInner {
    /**
     * 
     * @type {number}
     * @memberof GetDeliveryAreas200ResponseInnerGeometryAnyOfInner
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof GetDeliveryAreas200ResponseInnerGeometryAnyOfInner
     */
    lng: number;
}

/**
 * Check if a given object implements the GetDeliveryAreas200ResponseInnerGeometryAnyOfInner interface.
 */
export function instanceOfGetDeliveryAreas200ResponseInnerGeometryAnyOfInner(value: object): value is GetDeliveryAreas200ResponseInnerGeometryAnyOfInner {
    if (!('lat' in value) || value['lat'] === undefined) return false;
    if (!('lng' in value) || value['lng'] === undefined) return false;
    return true;
}

export function GetDeliveryAreas200ResponseInnerGeometryAnyOfInnerFromJSON(json: any): GetDeliveryAreas200ResponseInnerGeometryAnyOfInner {
    return GetDeliveryAreas200ResponseInnerGeometryAnyOfInnerFromJSONTyped(json, false);
}

export function GetDeliveryAreas200ResponseInnerGeometryAnyOfInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliveryAreas200ResponseInnerGeometryAnyOfInner {
    if (json == null) {
        return json;
    }
    return {
        
        'lat': json['lat'],
        'lng': json['lng'],
    };
}

export function GetDeliveryAreas200ResponseInnerGeometryAnyOfInnerToJSON(json: any): GetDeliveryAreas200ResponseInnerGeometryAnyOfInner {
    return GetDeliveryAreas200ResponseInnerGeometryAnyOfInnerToJSONTyped(json, false);
}

export function GetDeliveryAreas200ResponseInnerGeometryAnyOfInnerToJSONTyped(value?: GetDeliveryAreas200ResponseInnerGeometryAnyOfInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lat': value['lat'],
        'lng': value['lng'],
    };
}

